export const saveSellerDetailsAction = payload => {
    return {
        type: 'SAVE_SELLER_DETAILS',
        payload
    }
}